export function checkIfAwsWafNativeSdkAvailable() {
  return false;
}

export function initializeAwsWafTokenProvider(_params: Params) {
  return Promise.resolve();
}

export function getAwsWafToken() {
  return Promise.resolve('');
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  applicationIntegrationUrl: string;
  domainName: string;
};
